// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"223":"world-flags","754":"web3"}[chunkId] || chunkId) + "-" + {"223":"946d881b549d78f95588","297":"64e76bd86464f40434eb","754":"43219c2a0f8e3e874e7e"}[chunkId] + ".chunk.js";
};